import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, Modal, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextUserInfo } from "../../../Layout/MainLayout";
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import RtlProvider from "../../../Components/RtlProvider"
import helper from "../../../helper";
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { MdCalculate, MdCheck, MdClose, MdExpandLess, MdExpandMore, MdList, MdOutlineSearch, MdReviews } from "react-icons/md";
import { TbEdit} from "react-icons/tb";
import '../../../Styles/react-tagsinput.css'
import AccessControl from "../../../Components/AccessControl";
import { useNavigate } from 'react-router-dom';
import packageApi from '../../../api/packageApi';

const PackageList = () => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const navigate = useNavigate();

    //table state
    const [columnFilters, setColumnFilters] = useState(
        [],
    );
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    //form and getdata
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),
    });

    const GetData = () => {
        var packageName = null;
        if (watch("packageName"))
            packageName = watch("packageName");

        const paginationData = {
            "packageName": packageName,
            "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
            "pageNumber": pagination.pageIndex + 1,
            "pageSize": pagination.pageSize,
        }

        if (!data.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        packageApi.GetPackageFilter(paginationData)
            .then((data) => {
                setData(data.data.data ? data.data.data.items : []);
                const rowcnt = data.data.data ? data.data.data.totalCount : 0;
                setRowCount(rowcnt);

            })
            .catch((error) => {
                console.log(error);
                setIsError(true);
            }).finally(() => {
                setIsError(false);
                setIsLoading(false);
                setIsRefetching(false);
            });
    };
    const onSubmit = () => {
        GetData();
    };
    const RefreshGrid = () => {
        GetData();
    }

    useEffect(() => {
        GetData();
    },
     [
        columnFilters, //re-fetch when column filters change
        globalFilter, //re-fetch when global filter changes
        pagination.pageIndex, //re-fetch when page index changes
        pagination.pageSize, //re-fetch when page size changes
        sorting, //re-fetch when sorting changes

    ]);
    const handleEditPackage = (id) => {
        navigate("/dashboard/Package/Edit/" + String(id));
    }

    const columns = useMemo(
        () => [

            {
                accessorKey: 'data.name',
                id: 'name',
                header: 'نام برنامه سفر',
                enableSorting: false,
            },
            {
                accessorKey: 'data.duration',
                id: 'duration',
                header: 'مدت زمان(روز)',
                enableSorting: true,
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data,
        enableFilters: false,
        enableRowSelection: false,
        enableExpandAll: false,
        getRowId: (row) => row.flightId,
        initialState: { showColumnFilters: true },
        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        muiToolbarAlertBannerProps: isError
            ? {
                color: 'error',
                children: 'Error loading data',
            }
            : undefined,
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        rowCount,
        state: {
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
        },

        muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                backgroundColor: 'rgb(113, 185, 172)',
                textAlign: 'right'
            },
        },
        muiTableBodyCellProps: ({ column }) => ({
            //conditionally style pinned columns
            sx: {
                textAlign: 'right',
            },
        }),
        muiTableBodyProps: {
            sx: {
                //stripe the rows, make odd rows a darker color
                '& tr:nth-of-type(odd) > td': {
                    backgroundColor: '#f5f5f5',
                },
            },
        },
        enableRowActions: true,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: ' ', //change header text
            },
        },
        positionActionsColumn: 'last',
        renderRowActions: ({ row }) => (
            (AccessControl.checkPermissions(userPermissions, ["Package:Edit"])) && <div dir="rtl">
                <Box >
                    {row.original.data?.id && <Tooltip title="ویرایش" placement="top">
                        <IconButton style={{ margin: '2px', borderRadius: 0 }} onClick={() => {
                            handleEditPackage(row.original.data?.id);
                        }}>
                            <TbEdit color='#4a148c' />
                        </IconButton>
                    </Tooltip>}
                </Box>
            </div>
        ),

    });
    return (
        <>
            <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                    <Typography component="h1" variant="h5" mb={2} >
                        لیست برنامه سفر      </Typography>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <Grid container spacing={1}>
                            <Grid item md={1.5} xs={3.5}>
                                <TextField
                                    label="نام برنامه سفر"
                                    {...register("packageName")}
                                />
                            </Grid>
                            <Grid item xs={12} spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
                                <Button type="submit" variant="contained" color="primary"  >
                                    جستجو
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </RtlProvider>
                <div dir="rtl">
                    <Box sx={{ marginTop: 1 }} >
                        <MaterialReactTable table={table} />
                    </Box>
                </div>

            </ThemeProvider>
        </>
    )
}
export default PackageList;